/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_stopwatch_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How accurate is the stopwatch?`)
};

const es_timer_stopwatch_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué tan preciso es el cronómetro?`)
};

const de_timer_stopwatch_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie genau ist die Stoppuhr?`)
};

const nl_timer_stopwatch_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe nauwkeurig is de stopwatch?`)
};

const fr_timer_stopwatch_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est la précision du chronomètre ?`)
};

const it_timer_stopwatch_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto è preciso il cronometro?`)
};

const pt_br2_timer_stopwatch_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual a precisão do cronômetro?`)
};

const pt_timer_stopwatch_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a precisão do cronómetro?`)
};

const ja_timer_stopwatch_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストップウォッチの精度はどのくらいですか？`)
};

const zh_timer_stopwatch_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`秒表的精度如何？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_stopwatch_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_stopwatch_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_stopwatch_faq2_q", locale)
	if (locale === "en") return en_timer_stopwatch_faq2_q(inputs)
	if (locale === "es") return es_timer_stopwatch_faq2_q(inputs)
	if (locale === "de") return de_timer_stopwatch_faq2_q(inputs)
	if (locale === "nl") return nl_timer_stopwatch_faq2_q(inputs)
	if (locale === "fr") return fr_timer_stopwatch_faq2_q(inputs)
	if (locale === "it") return it_timer_stopwatch_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_stopwatch_faq2_q(inputs)
	if (locale === "pt") return pt_timer_stopwatch_faq2_q(inputs)
	if (locale === "ja") return ja_timer_stopwatch_faq2_q(inputs)
	return zh_timer_stopwatch_faq2_q(inputs)
};